export default __webpack_public_path__ + "static/media/bank-card-navy.1c9c3e79.svg";